var React = require('react');

function IconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.25"},[React.createElement("path",{"d":"M7.92 16.7975C5.11668 16.7975 2.54363 17.8057 0.525741 19.4849C0.508655 19.1589 0.5 18.8305 0.5 18.5C0.500001 8.54588 8.34785 0.499999 18 0.5C27.6521 0.500001 35.5 8.54588 35.5 18.5C35.5 28.4541 27.6521 36.5 18 36.5C17.676 36.5 17.3542 36.4909 17.0346 36.4731C18.6828 34.3959 19.67 31.7451 19.67 28.86C19.67 22.211 14.4222 16.7975 7.92 16.7975Z","stroke":"#F9F8F2","key":0}),React.createElement("path",{"d":"M1.5 29.0002C1.5 25.3749 4.22054 22.5002 7.5 22.5002C10.7795 22.5002 13.5 25.3749 13.5 29.0002C13.5 32.6256 10.7795 35.5002 7.5 35.5002C4.22054 35.5002 1.5 32.6256 1.5 29.0002Z","stroke":"#F9F8F2","key":1})]));
}

IconInline.defaultProps = {"viewBox":"0 0 36 37","fill":"none"};

module.exports = IconInline;

IconInline.default = IconInline;
